<template>
  <form class="flex flex-col">
    <JoszakiInput
      v-model.trim="v.email.$model"
      :label="$t('login.provideEmail')"
      :placeholder="$t('login.emailPlaceholder')"
      :validation-state="v.email"
    />
    <JoszakiInput
      v-model="v.password.$model"
      :validation-state="v.password"
      :label="$t('login.providePassword')"
      :placeholder="$t('login.passwordPlaceholder')"
      type="password"
      class="mb-2"
    />

    <PasswordRecoveryModal
      :is-open="isPasswordRecoveryModalOpen"
      @close="isPasswordRecoveryModalOpen = false"
      @submitted="isPasswordRecoveryModalOpen = false"
    />
    <NoPasswordModal
      :is-open="noPasswordModalOpen"
      :email="formData.email"
      :variant="noPasswordModalVariant"
      :navigate-on-success="navigateOnSuccess"
      @close="noPasswordModalOpen = false"
      @success="$emit('success')"
    />
    <a class="mb-4 block" @click="isPasswordRecoveryModalOpen = true">
      {{ $t("login.forgotPassowrd") }}
    </a>

    <div v-if="requestError" class="mb-4">
      <transition name="bounce" mode="in-out">
        <JoszakiPill type="warning" class="text-xs">{{
          requestError
        }}</JoszakiPill>
      </transition>
    </div>
    <JoszakiButton
      :is-submit="true"
      :expanded="true"
      size="lg"
      :loading="submitting"
      class="mb-4 mt-auto"
      @click="submitLoginForm"
    >
      {{ $t("login.loginButton") }}
    </JoszakiButton>
    <GoogleLoginButton
      :navigate-on-success="navigateOnSuccess"
      @success="$emit('success')"
    />
    <OAuthLinkPrompt v-if="oauthNeedsLinking" />
    <div v-if="hasRegistrationLink" class="text-center pt-8">
      {{ $t("login.noAccountYet") }}
      <NuxtLink :to="localePath({ name: 'registrationPage' })">
        {{ $t("login.register") }}
      </NuxtLink>
      <GoogleLoginButton
        v-if="showGoogleRegister"
        request-phone
        :show-divider="false"
        :label="$t('login.registerWithGoogle')"
        :navigate-on-success="navigateOnSuccess"
        class="mt-2"
        @success="$emit('success')"
      />
    </div>
  </form>
</template>

<script>
import { ref, useRoute } from "@nuxtjs/composition-api";
import { useLoginForm } from "./useLoginForm";
import PasswordRecoveryModal from "./PasswordRecoveryModal.vue";
import NoPasswordModal from "./NoPasswordModal.vue";
import GoogleLoginButton from "./GoogleLoginButton.vue";
import OAuthLinkPrompt from "./OAuthLinkPrompt.vue";
import { useOAuthStore } from "~/components/_refactored/auth/composables/useOAuthStore";
import { isPhoneImportEnabled } from "~/components/_refactored/auth/composables/useGoogleLogin";

export default {
  name: "LoginForm",
  components: {
    PasswordRecoveryModal,
    NoPasswordModal,
    GoogleLoginButton,
    OAuthLinkPrompt,
  },
  props: {
    hasRegistrationLink: {
      type: Boolean,
      default: true,
    },
    /**
     * When false, the user stays on the current page after login and a
     * `success` event is emitted instead of navigating. Used for dialog login.
     */
    navigateOnSuccess: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const isPasswordRecoveryModalOpen = ref(
      route.value.query?.recover === "true"
    );
    const { needsLinking: oauthNeedsLinking } = useOAuthStore();

    const showGoogleRegister = isPhoneImportEnabled();

    return {
      isPasswordRecoveryModalOpen,
      oauthNeedsLinking,
      showGoogleRegister,
      ...useLoginForm({
        navigate: props.navigateOnSuccess,
        onSuccess: () => emit("success"),
      }),
    };
  },
};
</script>
